export const GRADES_ENUM = {
  PK: 'Prekindergarten',
  K: 'Kindergarten',
  PKE: 'Prekindergarten Educación Especial',
  PKM: '',
  EEA: 'Educación Especial Adulto',
  EPK: 'Etapa Preescolar',
};
